import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Settings", -1)),
    (_ctx.SelectedControl.AddRows)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.RowAction('add')))
          }, "Add row"),
          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.SelectedControl.DeleteRows)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.RowAction('delete')))
          }, "Remove row"),
          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.RowAction('back')))
      }, "Back")
    ])
  ]))
}